import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, trackPageView } from "../lib/analytics";

/**
 * Mount once at the App root.
 * Initialises GA4 (no-op on preview / when REACT_APP_GA4_ID is empty)
 * and emits a SPA page_view on every route change.
 */
export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    // Fire after the route renders so document.title is fresh
    const id = setTimeout(() => {
      trackPageView(location.pathname + location.search);
    }, 0);
    return () => clearTimeout(id);
  }, [location.pathname, location.search]);

  return null;
}
